import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelText as _vModelText, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { id: "closet-guide" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "page-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, "사이즈 가이드"),
  /*#__PURE__*/_createElementVNode("div", { class: "subtitle" }, "구매 전, 이 사이즈가 나에게 맞을지 내 옷 기록으로 미리 확인하세요")
], -1)
const _hoisted_3 = { class: "category-tabs" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "guide-body" }
const _hoisted_6 = { class: "fitcheck-card" }
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"fc-head\"><div class=\"fc-title\"><span class=\"fc-ic\">🔎</span> 핏 체크</div><span class=\"fc-unit-note\">cm 기준</span></div><p class=\"fc-desc\"> 사려는 옷의 <b>상품 사이즈표 실측</b>을 입력하면, 내가 <b>딱 맞다</b>고 평가한 옷들과 비교해 부위별로 판정해 드려요. </p>", 2)
const _hoisted_9 = {
  key: 0,
  class: "fc-sub"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("소분류 "),
  /*#__PURE__*/_createElementVNode("span", { class: "fc-sub-hint" }, "(총장·소매 등 길이 판정용)")
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "선택 안 함", -1)
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "fc-fields" }
const _hoisted_14 = {
  key: 0,
  class: "fc-target"
}
const _hoisted_15 = { class: "fc-input-row" }
const _hoisted_16 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_17 = { class: "ov-ic" }
const _hoisted_18 = { class: "ov-text" }
const _hoisted_19 = { class: "ov-title" }
const _hoisted_20 = { class: "ov-desc" }
const _hoisted_21 = {
  key: 2,
  class: "fc-hint"
}
const _hoisted_22 = { class: "reco-card" }
const _hoisted_23 = { class: "reco-head" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "reco-title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "reco-ic" }, "📏"),
  /*#__PURE__*/_createTextVNode(" 내 추천 사이즈")
], -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "sep" }, "/", -1)
const _hoisted_26 = { class: "reco-cat" }
const _hoisted_27 = {
  key: 0,
  class: "reco-rows"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "reco-sec" }, "공통 부위", -1)
const _hoisted_29 = { class: "rr-part" }
const _hoisted_30 = {
  key: 0,
  class: "rr-val"
}
const _hoisted_31 = {
  key: 1,
  class: "rr-val muted"
}
const _hoisted_32 = { class: "rr-basis" }
const _hoisted_33 = { class: "reco-sec" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", { class: "sub" }, "소분류별", -1)
const _hoisted_35 = { class: "rr-part" }
const _hoisted_36 = { class: "rr-val" }
const _hoisted_37 = { class: "rr-basis" }
const _hoisted_38 = {
  key: 1,
  class: "reco-empty"
}
const _hoisted_39 = /*#__PURE__*/_createElementVNode("b", null, "핏 평가", -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("p", { class: "hint" }, "옷을 등록할 때 실측과 핏(작음/딱맞음/큼)을 남기면 이 표가 채워집니다.", -1)
const _hoisted_41 = {
  key: 2,
  class: "reco-foot"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categoryOptions, (opt) => {
        return (_openBlock(), _createElementBlock("button", {
          key: opt.value,
          class: _normalizeClass(["tab-btn", { active: _ctx.category === opt.value }]),
          onClick: ($event: any) => (_ctx.category = opt.value)
        }, _toDisplayString(opt.label), 11, _hoisted_4))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        (_ctx.lengthKeys.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _hoisted_10,
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.checkSub) = $event))
              }, [
                _hoisted_11,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subOptions, (s) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: s,
                    value: s
                  }, _toDisplayString(s), 9, _hoisted_12))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.checkSub]
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_13, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fields, (f) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "fc-field",
              key: f.key
            }, [
              _createElementVNode("label", null, [
                _createTextVNode(_toDisplayString(f.label) + " ", 1),
                (_ctx.recoMap[f.key] && _ctx.recoMap[f.key].recommended != null)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_14, " 내 추천 " + _toDisplayString(_ctx.recoMap[f.key].recommended) + _toDisplayString(f.unit), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  step: "0.1",
                  "onUpdate:modelValue": ($event: any) => ((_ctx.input[f.key]) = $event),
                  placeholder: f.unit
                }, null, 8, _hoisted_16), [
                  [
                    _vModelText,
                    _ctx.input[f.key],
                    void 0,
                    { number: true }
                  ]
                ]),
                _createElementVNode("span", {
                  class: _normalizeClass(["fc-verdict", _ctx.verdicts[f.key].cls])
                }, _toDisplayString(_ctx.verdicts[f.key].text), 3)
              ])
            ]))
          }), 128))
        ]),
        (_ctx.anyInput)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass(["fc-overall", _ctx.overall.cls])
            }, [
              _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.overall.icon), 1),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.overall.title), 1),
                _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.overall.desc), 1)
              ])
            ], 2))
          : (_openBlock(), _createElementBlock("div", _hoisted_21, " 위 칸에 상품 실측을 입력하면 실시간으로 판정됩니다. "))
      ]),
      _createElementVNode("aside", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, [
          _hoisted_24,
          _createElementVNode("button", {
            class: "unit-toggle",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleUnit && _ctx.toggleUnit(...args)))
          }, [
            _createElementVNode("span", {
              class: _normalizeClass({ on: !_ctx.toInch })
            }, "cm", 2),
            _hoisted_25,
            _createElementVNode("span", {
              class: _normalizeClass({ on: _ctx.toInch })
            }, "in", 2)
          ])
        ]),
        _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.getCategoryLabel(_ctx.category)), 1),
        (_ctx.hasReco)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_ctx.fitReco.common.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                    _hoisted_28,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fitReco.common, (row) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: _normalizeClass(["reco-row", { empty: row.recommended == null }]),
                        key: row.key
                      }, [
                        _createElementVNode("span", _hoisted_29, _toDisplayString(row.label), 1),
                        (row.recommended != null)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_30, [
                              _createTextVNode(_toDisplayString(_ctx.conv(row.recommended, row.unit)), 1),
                              _createElementVNode("em", null, _toDisplayString(_ctx.unit(row.unit)), 1)
                            ]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_31, "–")),
                        _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.basis(row)), 1)
                      ], 2))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fitReco.lengthGroups, (g) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "reco-rows",
                  key: g.key
                }, [
                  _createElementVNode("div", _hoisted_33, [
                    _createTextVNode(_toDisplayString(g.label) + " ", 1),
                    _hoisted_34
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(g.items, (it) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "reco-row",
                      key: it.subCategory
                    }, [
                      _createElementVNode("span", _hoisted_35, _toDisplayString(it.subCategory), 1),
                      _createElementVNode("span", _hoisted_36, [
                        _createTextVNode(_toDisplayString(_ctx.conv(it.row.recommended, g.unit)), 1),
                        _createElementVNode("em", null, _toDisplayString(_ctx.unit(g.unit)), 1)
                      ]),
                      _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.basis(it.row)), 1)
                    ]))
                  }), 128))
                ]))
              }), 128))
            ], 64))
          : (_openBlock(), _createElementBlock("div", _hoisted_38, [
              _createElementVNode("p", null, [
                _createTextVNode("아직 "),
                _hoisted_39,
                _createTextVNode("가 있는 " + _toDisplayString(_ctx.getCategoryLabel(_ctx.category)) + " 옷이 없어요.", 1)
              ]),
              _hoisted_40,
              _createElementVNode("button", {
                class: "reco-reg",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goRegister && _ctx.goRegister(...args)))
              }, "＋ 의류 등록")
            ])),
        (_ctx.hasReco)
          ? (_openBlock(), _createElementBlock("div", _hoisted_41, "‘딱 맞음’으로 평가한 옷들의 실측 범위를 기준으로 추정한 값이에요."))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}